var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1822.61 1201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".j{fill:url(#d);}.j,.k,.l,.m,.n,.o,.p,.q{isolation:isolate;opacity:.5;}.k{fill:url(#e);}.l{fill:url(#f);}.m{fill:url(#g);}.n{fill:url(#c);}.o{fill:url(#b);}.p{fill:url(#i);}.q{fill:url(#h);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -312.02,
    y1: 1979.63,
    x2: 1258.61,
    y2: 1979.63,
    gradientTransform: "translate(564 2546) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cce0f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#c2dcf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#a9d2ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7fc2e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#46abdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1e9cd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0075be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005b97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -399.54,
    y1: 1827.15,
    x2: 1101.82,
    y2: 1827.15,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -209.74,
    y1: 2121.45,
    x2: 1040.86,
    y2: 2121.45,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -473.7,
    y1: 1699.87,
    x2: 633.4,
    y2: 1699.87,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -71.03,
    y1: 2303.34,
    x2: 747.16,
    y2: 2303.34,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -524.1,
    y1: 1601.66,
    x2: 71.32,
    y2: 1601.66,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -564,
    y1: 1560.12,
    x2: -149.9,
    y2: 1560.12,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 98.28,
    y1: 2493.47,
    x2: 368.19,
    y2: 2493.47,
    xlinkHref: "#b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1822.24,498.06c-16.26,2.45-32.52,4.86-48.75,7.38-46.02,7.12-92.02,14.57-138.09,21.39-70.97,10.5-142.02,20.61-213.01,30.85-62.97,9.09-125.94,18.18-188.94,27.27-60.64,8.74-121.3,17.44-181.93,26.22-62.97,9.11-125.92,18.34-188.92,27.45-67.39,9.74-134.78,19.38-202.17,29.09-33.19,4.76-66.37,9.48-99.51,14.41-4.44,.67-8.16-.18-12.03-2.2-97.45-51.13-194.91-102.24-292.45-153.21-5.85-3.05-5.57-5.32-1.39-9.69,13.44-13.97,26.78-28.05,39.64-42.55,4.58-5.16,8.53-4.28,13.76-1.97,46.92,20.86,93.91,41.6,140.88,62.37,41.93,18.55,83.85,37.09,125.78,55.66,3.42,1.5,6.78,2.22,10.64,1.71,74.53-9.5,149.09-18.94,223.65-28.31,60.52-7.61,121.09-15.01,181.61-22.64,59.73-7.52,119.47-15.24,179.2-22.8,47.8-6.04,95.6-11.93,143.4-17.97,43.87-5.53,87.74-11.22,131.63-16.72,43.62-5.48,87.25-10.82,130.87-16.28,43.64-5.46,87.3-10.85,130.89-16.65,9.18-1.23,17.32-.28,25.79,3.72,25.83,12.19,51.96,23.68,77.98,35.5,3.98,1.8,7.89,3.79,11.82,5.69l-.37,2.24v.02Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1665.77,601.28c-12.23,5.76-24.42,11.61-36.68,17.3-58.74,27.15-117.73,53.74-176.1,81.61-19.47,9.3-40.08,11.75-60.61,15.33-99.3,17.37-198.68,34.43-298.02,51.55-108.39,18.69-216.78,37.28-325.15,55.99-79.48,13.71-158.94,27.47-238.38,41.4-6.68,1.18-12.07,.14-17.65-3.77-114.8-79.97-229.64-159.85-344.58-239.63-4.83-3.35-5.67-5.67-1.23-10.2,10.8-11.05,21.35-22.36,31.47-34.02,4.44-5.13,7.91-5.04,13.27-1.6,48.73,31.27,97.59,62.32,146.46,93.41,57.24,36.42,114.54,72.78,171.73,109.32,5.57,3.56,10.8,4.9,17.6,3.77,88.6-14.73,177.24-29.18,265.9-43.62,121.48-19.77,242.96-39.41,364.44-59.18,71.07-11.56,142.13-23.31,213.2-34.92,90.7-14.82,181.42-29.6,272.12-44.38,.49-.07,.99,.14,1.5,.21,.25,.49,.49,.95,.74,1.43h-.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1604.85,397.28c-18.02,2.1-35.13,4.09-52.22,6.13-47.29,5.62-94.59,11.31-141.88,16.84-43.15,5.02-86.33,9.81-129.48,14.75-38.23,4.39-76.43,8.9-114.64,13.32-42.9,4.97-85.82,9.9-128.72,14.85-38.74,4.46-77.5,8.95-116.23,13.41-38.23,4.42-76.45,8.86-114.68,13.27-39.01,4.51-78,9.02-117.02,13.53-23.91,2.78-47.85,5.57-71.76,8.37-4.56,.53-8.81-.44-13.07-2.04-81.96-30.67-163.92-61.35-245.94-91.88-6.45-2.41-6.11-4.72-1.85-9.18,16.1-16.86,32.19-33.74,47.78-51.06,5.02-5.57,9.69-6.31,16.51-4.16,49.98,15.77,100.04,31.24,150.06,46.81,15.01,4.67,30.02,9.32,45.05,13.97,12.53,3.86,25,.19,37.42-.83,31.82-2.57,63.6-5.78,95.39-8.79,36.49-3.42,72.96-6.89,109.43-10.31,30.23-2.84,60.45-5.64,90.7-8.49,37-3.47,74-6.96,111-10.43,30.48-2.84,60.98-5.57,91.49-8.49,30.48-2.91,60.94-6.04,91.42-8.93,25-2.38,50.02-4.58,75.02-6.8,33.63-2.98,67.25-5.9,100.85-8.88,18.25-1.62,36.49-3.35,54.74-5,7.79-.69,14.15,3.58,20.72,6.59,34.5,15.86,68.87,32.03,103.26,48.15,2.06,.97,4.53,1.43,6.64,5.25v.02Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1197.35,818.59c-10.55,4.95-21.04,9.94-31.61,14.85-60.15,27.82-120.32,55.59-180.48,83.42-16.65,7.7-33.14,15.7-49.91,23.1-16.95,7.49-35.43,9.13-53.33,12.86-129.23,26.9-258.5,53.54-387.71,80.52-7.54,1.57-12.79-.05-18.41-4.9-84.2-72.38-168.54-144.58-252.84-216.88-43.15-36.98-86.21-74.07-129.44-110.96-4.3-3.68-4.42-6.13-.56-10.06,9-9.13,17.95-18.39,26.34-28.07,4.67-5.41,8.14-5.23,13.6-.97,43.96,34.34,88.16,68.41,132.28,102.56,76.85,59.48,153.72,118.94,230.5,178.53,5.67,4.39,10.87,6.71,18.57,5.18,70.14-13.83,140.37-27.17,210.58-40.68,139.38-26.83,278.76-53.7,418.14-80.52,16.47-3.17,32.93-6.27,49.4-9.34,1.43-.25,2.94-.05,4.42-.05l.49,1.36-.05,.05Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1311.16,261.11c-14.36,2.71-28.72,2.54-42.92,3.68-43.52,3.47-87.07,6.5-130.62,9.5-34.18,2.36-68.36,4.28-102.54,6.64-33.12,2.29-66.21,5.02-99.35,7.38-25.83,1.85-51.66,3.33-77.5,5.13-33.65,2.36-67.27,4.95-100.92,7.35-25.05,1.78-50.16,2.84-75.11,5.34-22.64,2.27-43.38-5.71-64.73-10.15-39.2-8.19-78.19-17.46-117.23-26.34-2.5-.58-6.24-1.06-6.98-2.71-1.36-3.08,2.47-4.69,4.32-6.66,22.85-23.82,45.86-47.45,68.59-71.39,4.19-4.42,8.14-5.3,13.9-3.79,28.38,7.4,56.91,14.15,85.22,21.76,11.54,3.1,22.94,1.23,34.3,.67,30.04-1.5,60.03-3.77,90.03-5.85,42-2.91,83.99-6.01,125.99-8.9,19.56-1.34,39.18-2.36,58.74-3.65,29.23-1.92,58.44-3.98,87.67-5.87,24-1.55,48.03-2.98,72.06-4.44,3.52-.21,6.66,1.27,9.74,2.73,53.42,24.86,106.87,49.7,160.26,74.63,2.45,1.13,5.6,1.53,7.08,4.97v-.02Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M635.32,1076.26c-11.12,8.6-23.82,13.46-36.03,19.17-45.81,21.39-91.86,42.3-137.62,63.8-6.59,3.1-10.45,2.41-15.56-2.75-90.1-90.4-180.36-180.64-270.67-270.81-43.2-43.13-86.63-86.05-129.94-129.09-5-4.96-4.96-10.06,.09-15.29,1.83-1.87,3.72-3.7,5.46-5.67,8.3-9.46,6.68-11.82,18.89-.23,60.24,57.17,120.6,114.17,180.96,171.22,35.8,33.83,71.64,67.6,107.49,101.36,34.9,32.89,69.86,65.68,104.62,98.66,4.21,4,8.42,4.35,13.62,3.24,48.93-10.48,97.87-20.81,146.83-31.2,3.95-.83,7.91-1.64,11.84-2.45l.02,.02Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M414.1,1180.95c-13.94,6.48-27.91,12.93-41.83,19.45-3.93,1.85-5.76-.95-7.84-3.24-22.69-25-45.42-50-68.06-75.04-27.01-29.92-53.95-59.92-80.94-89.87-36.79-40.84-73.59-81.7-110.4-122.52-31.04-34.41-62.32-68.59-93.15-103.19-15.89-17.81-15.82-11.75,.16-29.69,7.54-8.46,7.65-8.02,15.7,.81,24.68,27.1,49.54,54.02,74.3,81.06,44.56,48.63,89.1,97.31,133.67,145.95,30.78,33.58,61.63,67.09,92.41,100.67,20.17,21.99,40.33,43.99,60.36,66.12,3.01,3.33,6.13,5.3,10.68,5.57,4.88,.3,9.69,1.34,14.55,2.06,.12,.62,.23,1.23,.37,1.85l.02,.02Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M932.19,86.81c-21.62,1.8-42.16,3.52-62.72,5.23-35.98,2.98-71.94,5.99-107.95,8.88-18.78,1.53-37.56,3.15-56.36,4.12-8.6,.44-15.82-5.06-23.66-7.86-6.85-2.43-17.34-3.49-19.01-9.16-1.78-6.08,7.77-11.19,12.56-16.37,21.16-22.87,42.88-45.23,64.27-67.87,3.47-3.68,6.52-4.93,11.59-2.57,57.51,26.62,115.14,53,172.7,79.51,2.73,1.25,6.01,1.87,8.56,6.13l.02-.02Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg2.6d4800519ed5890a15c7279bdcdd5ff9.svg";
export { ForwardRef as ReactComponent };